import ff from './ff';

export default class c5d { // 機能情報

static d_defs = {

/*
  DROP TABLE t_c41r;
  CREATE TABLE t_c41r (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER, 
    c41rb21f INTEGER,
    c41rc11s TEXT,
    c41rc31s TEXT,
    c41rcx1i INTEGER,
    c41rcy1t TEXT,
    c41rcy1f INTEGER,
    c41rcz1i INTEGER
    , CONSTRAINT c41r_unq1 UNIQUE (c41rb21f, c41rc11s, _vsn)
  );
  INSERT INTO t_c41r (_vsn, _ltt, c41rb21f, c41rc11s, c41rc31s, c41rcx1i, c41rcy1t, c41rcy1f, c41rcz1i)
  VALUES (1, 1, 1, '1', 'エントリー・抽選・予約', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c41r (_vsn, _ltt, c41rb21f, c41rc11s, c41rc31s, c41rcx1i, c41rcy1t, c41rcy1f, c41rcz1i)
  VALUES (1, 1, 1, '2', 'マスタ', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c41r (_vsn, _ltt, c41rb21f, c41rc11s, c41rc31s, c41rcx1i, c41rcy1t, c41rcy1f, c41rcz1i)
  VALUES (1, 1, 1, '3', 'その他', 9999, '2000-01-01 00:00:00', 1, 10);
  UPDATE t_c41r SET _fst = _key;
*/

  c41r: {
    0: {
      pfx: '役割情報',
      b_vsn: true,
      d_insFlds: {
        c41rb21f: -1,
        c41rc11s: '',
        c41rc31s: '',
      },
      dd_fldDefss: {
        c41rb21f: { 
          pfx: 'c20r_fst',
          type: 'Inp',
        },
        c41rc11s: {
          pfx: '権限分類ID',
          type: 'Inp',
          n_col: 5,
        },
        c41rc31s: {
//          pfx: '役割名',
          pfx: '権限分類名',
          type: 'Inp',
          n_col: 15,
        },
      },
    },
  },

/*
  DROP TABLE t_c410;
  CREATE TABLE t_c410 (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER, 
    c410b21f INTEGER,
    c410b41k INTEGER,
    c410b51k INTEGER,
    c410cx1i INTEGER,
    c410cy1t TEXT,
    c410cy1f INTEGER,
    c410cz1i INTEGER
    , CONSTRAINT c410_unq1 UNIQUE (c410b21f, c410b51k, c410b41k, _vsn)
  );
  INSERT INTO t_c410 (_vsn, _ltt, c410b21f, c410b41k, c410b51k, c410cx1i, c410cy1t, c410cy1f, c410cz1i)
  VALUES (1, 1, 1, 1, 1, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c410 (_vsn, _ltt, c410b21f, c410b41k, c410b51k, c410cx1i, c410cy1t, c410cy1f, c410cz1i)
  VALUES (1, 1, 1, 2, 1, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c410 (_vsn, _ltt, c410b21f, c410b41k, c410b51k, c410cx1i, c410cy1t, c410cy1f, c410cz1i)
  VALUES (1, 1, 1, 3, 1, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c410 (_vsn, _ltt, c410b21f, c410b41k, c410b51k, c410cx1i, c410cy1t, c410cy1f, c410cz1i)
  VALUES (1, 1, 1, 4, 1, 9999, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c410 (_vsn, _ltt, c410b21f, c410b41k, c410b51k, c410cx1i, c410cy1t, c410cy1f, c410cz1i)
  VALUES (1, 1, 1, 5, 2, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c410 (_vsn, _ltt, c410b21f, c410b41k, c410b51k, c410cx1i, c410cy1t, c410cy1f, c410cz1i)
  VALUES (1, 1, 1, 6, 2, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c410 (_vsn, _ltt, c410b21f, c410b41k, c410b51k, c410cx1i, c410cy1t, c410cy1f, c410cz1i)
  VALUES (1, 1, 1, 7, 2, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c410 (_vsn, _ltt, c410b21f, c410b41k, c410b51k, c410cx1i, c410cy1t, c410cy1f, c410cz1i)
  VALUES (1, 1, 1, 8, 2, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c410 (_vsn, _ltt, c410b21f, c410b41k, c410b51k, c410cx1i, c410cy1t, c410cy1f, c410cz1i)
  VALUES (1, 1, 1, 9, 2, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c410 (_vsn, _ltt, c410b21f, c410b41k, c410b51k, c410cx1i, c410cy1t, c410cy1f, c410cz1i)
  VALUES (1, 1, 1,10, 2, 9999, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c410 (_vsn, _ltt, c410b21f, c410b41k, c410b51k, c410cx1i, c410cy1t, c410cy1f, c410cz1i)
  VALUES (1, 1, 1, 11, 3, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c410 (_vsn, _ltt, c410b21f, c410b41k, c410b51k, c410cx1i, c410cy1t, c410cy1f, c410cz1i)
  VALUES (1, 1, 1, 12, 3, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c410 (_vsn, _ltt, c410b21f, c410b41k, c410b51k, c410cx1i, c410cy1t, c410cy1f, c410cz1i)
  VALUES (1, 1, 1, 13, 3, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c410 (_vsn, _ltt, c410b21f, c410b41k, c410b51k, c410cx1i, c410cy1t, c410cy1f, c410cz1i)
  VALUES (1, 1, 1, 14, 3, 9999, '2000-01-01 00:00:00', 1, 10);

  UPDATE t_c410 SET _fst = _key;

*/

  c410: {
    0: {
      pfx: '役割別機能情報',
      b_vsn: true,
      d_insFlds: {
        c410b21f: -1,
        c410c41f: -1,
        c410c51k: -1,
      },
      dd_fldDefss: {
        c410b21f: { 
          pfx: 'c20r_fst',
          type: 'Inp',
          n_col: 10,
        },
        c410b51k: { 
          pfx: 'c41r_key',
          type: 'Inp',
          n_col: 10,
        },
        c410b41k: { // c40r_key
//          pfx: '機能',
          pfx: '操作を許可する項目',
          type: 'Pck',
          n_col: 15,
        },
      },
    },
  },

};

};
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
